<template>
  <v-navigation-drawer
    app
    class="app--drawer"
    :mini-variant.sync="mini"
    v-model="drawer"
    :width="drawWidth"
    :dark="$vuetify.dark"
  >
    <v-toolbar color="primary darken-1" dark>
      <img :src="computeLogo" height="36" alt="PANDA LOAN MANAGEMENT SYSTEM" />
      <v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down"><strong>PANDA</strong> LOAN</span>
      </v-toolbar-title>
    </v-toolbar>
    <!-- menu -->
    <v-list v-if="items" dense nav>
      <template v-for="(item, i) in items">
        <v-subheader
          v-if="item.header"
          :key="`subheader-${i}`"
          v-text="item.header"
        />
        <!-- no children -->
        <list-item
          v-else-if="tool.isEmpty(item.children) && isShowMenu(privileges, item.code, dataType.PrivilegeType.READABLE)"
          :key="`item-${i}`"
          :to="item.to"
          :text="item.text"
          :icon="item.icon"
        ></list-item>
        <!-- has children -->
        <v-list-group
          v-else-if="isShowMenuByGroup(privileges, item.children, dataType.PrivilegeType.READABLE)"
          :key="item.title"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-for="child in item.children">
            <!-- no children -->
            <list-item
              v-if="tool.isEmpty(child.children) && isShowMenu(privileges, child.code, dataType.PrivilegeType.READABLE)"
              :key="child.title"
              :to="child.to"
              :text="child.text"
            ></list-item>
            <!-- has children -->
            <v-list-group
              v-else-if="isShowMenuByGroup(privileges, child.children, dataType.PrivilegeType.READABLE)"
              :key="child.title"
              no-action
              sub-group
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ child.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="subChild in child.children">
                <list-item
                  v-if="isShowMenu(privileges, subChild.code, dataType.PrivilegeType.READABLE)"
                  :key="subChild.title"
                  :to="subChild.to"
                  :text="subChild.text"
                ></list-item>
              </template>
            </v-list-group>
          </template>
        </v-list-group>
      </template>
    </v-list>
    <v-menu offset-y top origin="center center" transition="scale-transition">
      <template v-slot:activator="{ on }">
        <v-btn icon large text slot="activator" @click="showList" v-show="isShowBtn" v-on="on" style="position: fixed; top: 800px; left: 25px">
          <v-avatar size="50px">
            <img :src="accountInfo.avatarUrl" :alt="accountInfo.firstName" :title="accountInfo.firstName" />
          </v-avatar>
        </v-btn>
      </template>
      <v-list class="pa-0" style="width: 200px;" v-show="isShowList">
        <div class="user-content"  @click="hiddenList">
          <div class="avatarUrl">
            <v-avatar size="100px" style="margin: auto">
              <img :src="accountInfo.avatarUrl" :alt="accountInfo.firstName" :title="accountInfo.firstName" />
            </v-avatar>
          </div>
          <div class="employee" style="margin-top: 10px">
            <span>{{ accountInfo.employeeNo }}</span>
          </div>
          <div class="fullName">
            <span style="font-weight: 500;font-size: 20px">{{ accountInfo.fullName }}</span>
          </div>
          <div class="email">
            <span>{{ accountInfo.email }}</span>
          </div>
          <div>
            <span>Language: {{accountInfo.languagePreference}}</span>
          </div>
          <div>
          <span>VIP: {{accountInfo.vipSettings}}</span>
          </div>
          <div>
            <span>Consent: {{accountInfo.marketingConsent}}</span>
          </div>
          <div class="role" style="margin: 10px 0">
            <v-chip outlined color="#97b4ff">
              {{ accountInfo.role }}
            </v-chip>
          </div>
        </div>
        <v-divider></v-divider>
        <v-list-item
          v-for="(item, index) in profileMenus"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          style="padding: 0 20px"
          rel="noopener"
          :key="index"
          class="b-t"
        >
          <v-list-item-action v-if="item.icon" style="margin: 12px 10px">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <p v-show ="isShowName" style="position: fixed; top: 814px; left: 100px">{{ accountInfo.firstName }}</p>
    <v-dialog v-model="dialog.changePasswordDialog" persistent max-width="50%">
      <change-pass-card @hideDialog="hideDialog('CHANGE_PASSWORD')"></change-pass-card>
    </v-dialog>
    <v-dialog v-model="dialog.signOutDialog" persistent max-width="30%">
      <sign-out @hideSignOutDialog="hideSignOutDialog()"></sign-out>
    </v-dialog>
    <div style="position: fixed; top: 870px; left: 10px; display: flex; justify-content: space-around; width: 160px">
      <v-btn icon @click="showSystem">
        <img :src="computeSystemLogo" height="30"/>
      </v-btn>
      <p style="margin-top: 8px">System</p>
    </div>
    <div class="system" v-if="isShowSystem">
      <div v-for="(item, index) in authArray" :key="index" class="circleItem">
        <div class="item" @click="judgeEnvironment(item)" :title="item.title">
          <v-img :src="item.src" max-width="32" :class="item.class" style="border: 1px solid #ccc;border-radius: 50%"></v-img>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>
<script>
import menu from '@/api/menu'
import foxLogo from '@/assets/images/fox_logo.png'
import zebraLogo from '@/assets/images/zebra_logo.png'
import slothLogo from '@/assets/images/sloth_logo.png'
import oamLogo from '@/assets/images/oam_logo.png'
import antLogo from '@/assets/images/ant_logo.png'
import bambooLogo from '@/assets/images/bamboo_logo.png'
import eagleLogo from '@/assets/images/eagle_logo.png'
// import ListGroup from '@/components/widget/list/Group'
import ListItem from '@/components/widget/list/Item'
import logo from '@/assets/images/logo.png'
import systemLogo from '@/assets/images/icon_system.png'
import { Authentication, DataType, Tool } from '@/util/index'
import ChangePassCard from '@/views/system/ChangePassCard'
import SignOut from '@/views/system/SignOut'
const tool = new Tool()
export default {
  name: 'AppDrawer',
  components: {
    // ListGroup,
    ListItem,
    ChangePassCard,
    SignOut
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
    drawWidth: {
      type: [Number, String],
      default: '260'
    },
    showDrawer: Boolean,
    privileges: {
      type: Array,
      default: () => []
    },
    isShowList: {
      type: Boolean,
      default: false
    },
    isShowBtn: {
      type: Boolean,
      default: true
    },
    isShowName: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      mini: false,
      items: menu,
      drawer: true,
      scrollSettings: {
        maxScrollbarLength: 160
      },
      dataType: DataType,
      tool: new Tool(),
      accountInfo: {
        avatarUrl: 'https://arbfintech-panda.s3-ap-southeast-1.amazonaws.com/avatar/ronaldo.png',
        firstName: ''
      },
      profileMenus: [
        {
          icon: 'cached',
          title: 'Change Password',
          click: () => {
            this.dialog.changePasswordDialog = true
            this.hiddenList()
          }
        },
        {
          icon: 'power_settings_new',
          title: 'Sign Out',
          click: () => {
            this.dialog.signOutDialog = true
            this.hiddenList()
          }
        }
      ],
      dialog: {
        changePasswordDialog: false,
        signOutDialog: false
      },
      isShowSystem: false,
      accessToken: '',
      authArray: [],
      languages: DataType.Languages,
      consentSettings: DataType.ConsentSettings,
      vipSettings: DataType.VipSettings,
      showItems: [
        {
          title: 'BAMBOO',
          test: 'https://bamboo.mk2.im/#/welcome',
          release: 'https://bamboo3.sztus.com/#/welcome',
          code: DataType.PrivilegeCode.BAMBOO_SYSTEM,
          src: bambooLogo,
          class: 'green'
        },
        {
          title: 'FOX',
          test: 'https://fox.mk2.im/#/welcome',
          release: 'https://fox3.sztus.com/#/welcome',
          code: DataType.PrivilegeCode.FOX_SYSTEM,
          src: foxLogo,
          class: 'white'
        },
        {
          title: 'EAGLE',
          test: 'https://eagle.mk2.im/#/welcome',
          release: 'https://eagle3.sztus.com/#/welcome',
          code: DataType.PrivilegeCode.EAGLE_SYSTEM,
          src: eagleLogo,
          class: 'yellow'
        },
        {
          title: 'ANT',
          test: 'https://ant.mk2.im/#/welcome',
          release: 'https://ant3.sztus.com/#/welcome',
          code: DataType.PrivilegeCode.ANT_SYSTEM,
          src: antLogo,
          class: 'white'
        },
        {
          title: 'SLOTH',
          test: 'https://sloth3.sztcu.com/#/welcome',
          release: 'https://sloth3.sztus.com/#/welcome',
          code: DataType.PrivilegeCode.SLOTH_SYSTEM,
          src: slothLogo,
          class: 'white'
        },
        {
          title: 'ZEBRA',
          test: 'https://zebra.mk2.im/#/welcome',
          release: 'https://zebra3.sztus.com/#/welcome',
          code: DataType.PrivilegeCode.ZEBRA_SYSTEM,
          src: zebraLogo,
          class: 'white'
        },
        {
          title: 'OAM',
          test: 'https://oam.mk2.im/#/welcome',
          release: 'https://oam3.sztus.com/#/welcome',
          code: DataType.PrivilegeCode.OAM_SYSTEM,
          src: oamLogo,
          class: 'white'
        }
      ]
    }
  },
  computed: {
    computeLogo () {
      return logo
    },
    computeSystemLogo () {
      return systemLogo
    }
  },
  watch: {
    showDrawer: {
      handler (val) {
        this.drawer = val
      },
      immediate: true
    }
  },
  destroyed () {
    this.$eventBus.$off('updateAccount')
  },
  mounted () {
    this.$eventBus.$on('updateAccount', target => {
      this.initAccountMenu()
    })
    const accessToken = localStorage.getItem('Access-Token')
    this.accessToken = accessToken
  },
  methods: {
    isShowMenu (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    },
    isShowMenuByGroup (privileges, items, value) {
      let result = false
      if (this.tool.isNotEmpty(items)) {
        for (const item of items) {
          if (this.tool.isNotEmpty(item.children)) {
            result |= this.isShowMenuByGroup(privileges, item.children, value)
          } else {
            if (Authentication.matchElementPrivilege(privileges, item.code, value)) {
              result = true
              break
            }
          }
        }
      }
      return result
    },
    async initAccountMenu () {
      const account = this.store.getters.getAccount
      const selectedLanguage = this.languages.find(lang => lang.value === account.languagePreference)?.text || ''
      const consentSettings = this.consentSettings.find(consent => consent.value === account.marketingConsent)?.text || ''
      const vipSettings = this.vipSettings.find(vipSettings => vipSettings.value === account.vipSettings)?.text || ''
      this.accountInfo = {
        avatarUrl: tool.isEmpty(account) ? '' : tool.isNotEmpty(account.avatarUrl) ? account.avatarUrl : 'https://arbfintech-panda.s3-ap-southeast-1.amazonaws.com/avatar/ronaldo.png',
        firstName: tool.isEmpty(account) ? '' : tool.isNotEmpty(account.firstName) ? account.firstName : '',
        employeeNo: tool.isEmpty(account) ? '' : tool.isNotEmpty(account.employeeNo) ? account.employeeNo : '',
        fullName: tool.isEmpty(account) ? '' : tool.isNotEmpty(account.middleName) ? `${account.firstName}${account.middleName}${account.lastName}` : `${account.firstName}${account.lastName}`,
        email: tool.isEmpty(account) ? '' : tool.isNotEmpty(account.email) ? account.email : '',
        role: tool.isNotEmpty(this.$store.getters.getRoleName) ? this.$store.getters.getRoleName : '',
        languagePreference: selectedLanguage,
        marketingConsent: consentSettings,
        vipSettings: vipSettings
      }
    },
    showList () {
      this.$eventBus.$emit('updateIsShowList', true)
      this.$eventBus.$emit('updateIsShowBtn', false)
      this.$eventBus.$emit('updateIsShowName', false)
    },
    hideDialog () {
      this.dialog.changePasswordDialog = false
    },
    hideSignOutDialog () {
      this.dialog.signOutDialog = false
    },
    hiddenList () {
      this.$eventBus.$emit('updateIsShowList', false)
      this.$eventBus.$emit('updateIsShowBtn', true)
      this.$eventBus.$emit('updateIsShowName', true)
    },
    showSystem () {
      this.listItem()
      this.isShowSystem = !this.isShowSystem
    },
    listItem () {
      this.authArray = []
      for (const item of this.showItems) {
        if (this.isShowElement(this.privileges, item.code, DataType.PrivilegeType.EXECUTABLE)) {
          this.authArray.push(item)
        }
      }
    },
    isShowElement (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    },
    judgeEnvironment (item) {
      if (tool.isEmpty(this.accessToken)) {
        this.$router.replace({ path: '/sign-in' })
        return false
      }
      switch (process.env.NODE_ENV) {
        case 'develop':
          window.open(item.test + '?t=' + this.accessToken, '_blank')
          break
        case 'production':
          window.open(item.release + '?t=' + this.accessToken, '_blank')
          break
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .app--drawer
    overflow: visible !important
    .drawer-menu--scroll
      height: calc(100vh - 48px)
      overflow: auto

  .user-content
    padding: 15px 10px 5px
  .user-content > div
    text-align: center
</style>
<style>
  .system {
    position: fixed;
    top: 873px;
    z-index: 999;
    left: 261px;
    display: flex;
    justify-content: center;
    color: white;
    animation-duration: 1.5s;
    animation-name: slidein
  }
  .system  .item {
    padding: 0 16px
  }

  @keyframes slidein {
    from {
      left: -85px;
    }

    to {
      left: 261px;
    }
  }
  .white {
    background-color: #fff;
  }
  .grey {
    background-color: #ccc;
  }
  .green {
    background-color: green;
  }
  .yellow {
    background-color: yellow;
  }
  .b-t{
    border-bottom: 1px solid #CCC;
  }
</style>
